export const singleBar = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  legend: {
    orient: 'vertical',
    x: 'left',
    data: []
  },
  xAxis: [{
    type: 'category',
    data: [],
    axisTick: {
      alignWithLabel: true
    }
  }],
  yAxis: [{
    type: 'value'
  }],
  series: [{
    name: '',
    type: 'bar',
    barWidth: '30%',
    data: []
  }]
}

export const bar = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985'
      }
    }
  },
  legend: {
    orient: 'vertical',
    x: 'left',
    data: []
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: {
    type: 'category',
    axisPointer: {
      type: 'shadow'
    },
    data: []
  },
  yAxis: {
    type: 'value'
  },
  series: [{
    name: '',
    type: 'bar',
    data: []
  }]
}

export const area = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985'
      }
    }
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: [{
    type: 'category',
    boundaryGap: false,
    data: []
  }],
  yAxis: [{
    type: 'value'
  }],
  series: [{
    type: 'line',
    name: '',
    areaStyle: {
      normal: {}
    },
    data: []
  }]
}

export const line = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985'
      }
    }
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: []
  },
  yAxis: [{
    type: 'value'
  }],
  series: [{
    name: '',
    type: 'line',
    data: []
  }]
}

export const pie = {
  tooltip: {
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c} ({d}%)'
  },
  legend: {
    orient: 'vertical',
    left: 'left',
    data: []
  },
  series: [{
    name: '',
    type: 'pie',
    radius: '55%',
    center: ['50%', '60%'],
    data: [],
    itemStyle: {
      emphasis: {
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowColor: 'rgba(0, 0, 0, 0.5)'
      }
    }
  }]
}

export const NoLegendPie = {
  tooltip: {
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c} ({d}%)'
  },
  series: {
    name: '',
    type: 'pie',
    radius: '65%',
    center: ['50%', '40%'],
    label: {
      normal: {
        show: false,
        position: 'right'
      }
    },
    data: []
  }
}

export function getPieOption(data, config, name) {
  let defaultOp = JSON.parse(JSON.stringify(config.NoLegendPie))
  defaultOp.series.name = name
  defaultOp.series.data = data.map((item) => ({
    name: item.name,
    value: item.value
  }))
  return defaultOp
}

export const doublePie = {
  tooltip: {
    trigger: 'item',
    formatter: '{a} <br/>{b}: {c} ({d}%)'
  },
  legend: {
    orient: 'vertical',
    x: 'left',
    data: []
  },
  series: [{
      name: '',
      type: 'pie',
      selectedMode: 'single',
      radius: [0, '30%'],

      label: {
        normal: {
          position: 'inner'
        }
      },
      labelLine: {
        normal: {
          show: false
        }
      },
      data: []
    },
    {
      name: '',
      type: 'pie',
      radius: ['40%', '55%'],
      data: []
    }
  ]
}

export const doubleLine = {
  tooltip: {
    trigger: 'axis'
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: []
  },
  yAxis: [{
    type: 'value'
  }],
  series: [{
    name: '',
    type: 'line',
    data: []
  }, {
    name: '',
    type: 'line',
    data: []
  }]
}

export const multipleArea = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985'
      }
    }
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: [{
    type: 'category',
    boundaryGap: false,
    data: []
  }],
  yAxis: [{
    type: 'value'
  }],
  series: []
}

export const multipleLine = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985'
      }
    }
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: [{
    type: 'category',
    boundaryGap: false,
    data: []
  }],
  yAxis: {
    type: 'value'
  },
  series: []
}

export function getMultipleLineOption(data, config) {
  let defaultOp = JSON.parse(JSON.stringify(config.multipleLine))
  defaultOp.xAxis[0].data = data.xAxis
  defaultOp.series = data.yAxis.map((item) => ({
    name: item.name,
    data: item.value,
    type: 'line'
  }))
  return defaultOp
}

export function getMultipleAreaOption(data, config) {
  let defaultOp = JSON.parse(JSON.stringify(config.multipleArea))
  defaultOp.xAxis[0].data = data.xAxis
  defaultOp.series = data.yAxis.map((item) => ({
    name: item.name,
    data: item.value,
    type: 'line',
    areaStyle: {
      normal: {}
    }
  }))
  return defaultOp
}

export function getSinglePieOption(data, config) {
  let defaultOp = JSON.parse(JSON.stringify(config.pie))
  defaultOp.legend.data = data.map((item) => (item.name))
  defaultOp.series[0].data = data.map((item) => ({
    name: item.name,
    value: item.value
  }))
  return defaultOp
}

export function getDoublePieOption(data, config, name = ['', '']) {
  let defaultOp = JSON.parse(JSON.stringify(config.doublePie))
  defaultOp.legend.data = data.outer.map((item) => (item.name))
  defaultOp.series[0].data = data.inner.map((item) => ({
    name: item.name,
    value: item.value
  }))
  defaultOp.series[0].name = name[0]

  defaultOp.series[1].data = data.outer.map((item) => ({
    name: item.name,
    value: item.value
  }))
  defaultOp.series[1].name = name[1]

  return defaultOp
}

export function getSingleBarOption(data, config) {
  let defaultOp = JSON.parse(JSON.stringify(config.bar))
  defaultOp.legend.data = data.yAxis.map((item) => (item.name))
  defaultOp.xAxis.data = data.xAxis
  defaultOp.series = data.yAxis.map((item) => ({
    name: item.name,
    data: item.value,
    stack: item.stack,
    type: 'bar'
  }))
  return defaultOp
}

export function getBarOption(data, config, name) {
  let defaultOp = JSON.parse(JSON.stringify(config.bar))
  defaultOp.xAxis.data = data.xAxis
  defaultOp.series[0].data = data.yAxis
  defaultOp.series[0].name = name
  return defaultOp
}

export function getDoubleLineOption(data, config) {
  let defaultOp = JSON.parse(JSON.stringify(config.doubleLine))
  defaultOp.xAxis[0].data = data.xAxis
  defaultOp.series = data.yAxis.map((item) => ({
    name: item.name,
    data: item.value,
    type: 'line'
  }))
  return defaultOp
}



// WEBPACK FOOTER //
// ./src/util/echart-config.js